import { useQuery } from '@apollo/client'
import { getUser as getUserGql } from 'src/graphql/queries/getUser.gql'

const useUser = (variables, options = {}) => {
   const { data, error, networkStatus, refetch, loading } = useQuery(getUserGql, {
      variables,
      fetchPolicy: 'cache-and-network',
      ...options
   })

   return {
      user: data?.user,
      error,
      loading,
      networkStatus,
      refetch
   }
}

export default useUser
